// src/components/HomeServices.js

import React from 'react';
// ✅ Import the Link component
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import '../Styles/HomeServices.css';

import home_services_hmo_img2 from '../images/home_servicesimg1.webp';
import home_services_hc_img1 from '../images/home_servicesimg2.webp';
import home_services_fa_img3 from '../images/home_servicesimg3.webp';
import home_services_gr_img4 from '../images/home_servicesimg4.webp';


// Your useIntersectionObserver hook and AnimateOnScroll component remain the same...
const useIntersectionObserver = (options) => {
  const [entry, setEntry] = useState(null);
  const [node, setNode] = useState(null);
  const observer = useRef(null);

  useEffect(() => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setEntry(entry);
        if (observer.current) observer.current.disconnect();
      }
    }, options);

    const { current: currentObserver } = observer;
    if (node) currentObserver.observe(node);

    return () => currentObserver.disconnect();
  }, [node, options]);

  return [setNode, entry];
};

const AnimateOnScroll = ({ children, animationClass }) => {
  const [ref, entry] = useIntersectionObserver({ threshold: 0.1 });
  return (
    <div ref={ref} className={`scroll-animate ${entry?.isIntersecting ? animationClass : ''}` }>
      {children}
    </div>
  );
};


const HomeServices = () => {
  return (
    <div className="home-services-section">
      <AnimateOnScroll animationClass="slide-in-left">
        <h2 className="home-services-title">OUR SERVICES</h2>
      </AnimateOnScroll>
      <div className="home-services-title-underline"></div>
      <div className="home-services-cards-container">
        {/* Card 1: HAIR CARE */}
        <AnimateOnScroll animationClass="pop-up">
          <div className="home-services-card">
            <img src={home_services_hc_img1}
             alt="HAIR CARE Services" 
             className="home-services-card-image"
             loading="lazy"
             width="600"  // <-- Replace with your image's actual width
             height="750" // <-- Replace with your image's actual height 
             />
            <div className="home-services-card-overlay">
              <h3>HAIR CARE</h3>
              <h3>SERVICES</h3>
              <button className="home-services-card-button">
                 {/* ✅ Use Link instead of <a> */}
                <Link to='/Service/service=hair-care' className='hero-button-link'>- READ MORE</Link>
              </button>
            </div>
          </div>
        </AnimateOnScroll>

        {/* Card 2: HAIR MAKE OVER */}
        <AnimateOnScroll animationClass="pop-up">
          <div className="home-services-card">
            <img src={home_services_hmo_img2} alt="HAIR MAKE OVER Services" 
            className="home-services-card-image" 
            loading="lazy"
             width="600"  // <-- Replace with your image's actual width
             height="750" // <-- Replace with your image's actual height 
             />
            <div className="home-services-card-overlay">
              <h3>HAIR MAKE OVER</h3>
              <h3>SERVICES</h3>
              <button className="home-services-card-button">
                 {/* ✅ Use Link instead of <a> */}
                <Link to='/Service/service=hair-makeover' className='hero-button-link'>- READ MORE</Link>
              </button>
            </div>
          </div>
        </AnimateOnScroll>

        {/* Card 3: FACIALS */}
        <AnimateOnScroll animationClass="pop-up">
          <div className="home-services-card">
            <img src={home_services_fa_img3} alt="FACIALS Services" 
            className="home-services-card-image" 
            loading="lazy"
             width="600"  // <-- Replace with your image's actual width
             height="750" // <-- Replace with your image's actual height 
             />
            <div className="home-services-card-overlay">
              <h3>FACIALS</h3>
              <h3>SERVICES</h3>
              <button className="home-services-card-button">
                 {/* ✅ Use Link instead of <a> */}
                <Link to='/Service/service=facials' className='hero-button-link'>- READ MORE</Link>
              </button>
            </div>
          </div>
        </AnimateOnScroll>

        {/* Card 4: GROOMING */}
        <AnimateOnScroll animationClass="pop-up">
          <div className="home-services-card">
            <img src={home_services_gr_img4} alt="GROOMING Services" 
            className="home-services-card-image" 
            loading="lazy"
             width="600"  // <-- Replace with your image's actual width
             height="750" // <-- Replace with your image's actual height 
             />
            <div className="home-services-card-overlay">
              <h3>GROOMING</h3>
              <h3>SERVICES</h3>
              <button className="home-services-card-button">
                 {/* ✅ Use Link instead of <a> */}
                <Link to='/Service/service=grooming' className='hero-button-link'>- READ MORE</Link>
              </button>
            </div>
          </div>
        </AnimateOnScroll>
      </div>
    </div>
  );
};

export default HomeServices;